import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {fetchMaintenanceBanner} from "modules/dashboard/_redux/dashboard/dashboardActions";

export function NotificationBanner({banner}) {
    const dispatch = useDispatch();
    const maintenanceBanner = useSelector(
        (state) => state.dashboard.maintenanceBanner
    );

    useEffect(() => {
        if (!banner) dispatch(fetchMaintenanceBanner());
    }, [banner, dispatch]);

    const displayBanner = banner || maintenanceBanner;

    return displayBanner ? (
        <div className="header-below-strip">
            <p>{displayBanner}</p>
        </div>
    ) : null;
};
